<template>
  <section class="my-5">

    <div class="form-content">
      <h3>ショッピング会員登録申込完了</h3>
      <p class="mt-5"><strong>マナビス化粧品</strong><small>＜info@manavis-cosme.co.jp＞</small></p>
      <p class="my-5">真奈 美須子 様</p>
      <p class="my-5">この度は、マナビス化粧品ショッピング会員登録にお申込みいただき、誠にありがとうございます。</p>
      <p class="my-5">ショッピング会員登録手続き終了後、ご注文の商品を発送いたします。</p>
      <p class="my-5">
        ------------------------------------------------------------------------------------------<br>
        <br>
        ◇申込者情報◇<br>
        <br>
        ------------------------------------------------------------------------------------------
      </p>
      <p class="my-5">
        メールアドレス：info@manavis-cosme.co.jp<br>
        氏名：真奈&emsp;美須子<br>
        氏名<span class="fs-08">（フリガナ）</span>：マナ&emsp;ビスコ<br>
        性別：女性<br>
        配偶者：無し<br>
        生年月日：0000/00/00<br>
        郵便番号：2790032<br>
        住所：千葉県浦安市千鳥15-9<br>
        住所<span class="fs-08">（フリガナ）</span>：チバケンウラヤスシチドリ15バンチ8<br>
        住所<span class="fs-08">（建物名）</span>：マナビスマンション101<br>
        住所<span class="fs-08">（その他）</span>：浦安舞子方<br>
        配送時連絡先：携帯電話番号<br>
        携帯電話番号：0888888888<br>
        自宅電話番号：<br>
        FAX番号：<br>
        スポンサーの氏名：浦安&emsp;舞子<br>
        スポンサーの氏名<span class="fs-08">（フリガナ）</span>：ウラヤス&emsp;マイコ<br>
        スポンサーの会員番号：2<br>
        スポンサーの電話番号：9999999999<br>
        パスワード：xxxxxxxxxxxx<br>
        当社からの広告等のメール・SMS・FAX送信：承諾しない
      </p>
      <p class="my-5">
        ------------------------------------------------------------------------------------------<br>
        <br>
        ◇商品ご注文内容◇<br>
        <br>
        ------------------------------------------------------------------------------------------
      </p>
      <p class="my-5">
        お支払い方法に【銀行振込】をご選択いただいておりましたので、下記の通り、お振込金額とお振込先をご案内致します。<br>
        <br>
        ※商品の発送は入金確認後となります。<br>
        ※三井住友銀行は平日13:00迄、ゆうちょ銀行は平日11:30迄にご入金を頂ければ、当日発送が可能となります。<br>
        但し、当社にて入金確認ができない場合、ご指定日にお届けできない事がございますので、予めご了承願います。<br>
        ■お振込み口座<br>
        金融機関名&emsp;三井住友銀行<br>
        支店名&emsp;&emsp;&emsp;浦安支店<br>
        預金種類&emsp;&emsp;普通預金<br>
        口座番号&emsp;&emsp;6769848<br>
        口座名義&emsp;&emsp;株式会社マナビス化粧品&emsp;カ）マナビスケショウヒン<br>
        <br>
        金融機関名&emsp;ゆうちょ銀行<br>
        記号&emsp;&emsp;&emsp;&emsp;00160-8<br>
        番号&emsp;&emsp;&emsp;&emsp;427377<br>
        口座名義&emsp;&emsp;株式会社マナビス化粧品&emsp;カ）マナビスケショウヒン<br>
        <br>
        ■送付先<br>
        〒279-0032<br>
        千葉県浦安市千鳥15-9<br>
        浦安&emsp;舞子&emsp;様
        <br>
        配送希望日：2022/00/00<br>
        配送希望時間帯：指定なし<br>
        <br>
        ■購入商品<br>
        薬用スキンウォッシュ<br>
        ￥5,250（税込み）<br>
        個数：1個<br>
        ----------<br>
        フローラ&emsp;ファーストセラム<br>
        ￥7,350（税込み）<br>
        個数：1個<br>
        ----------<br>
        <br>
        代引手数料：￥0<br>
        送料：￥0<br>
        合計金額：￥12,600<br>
        （内消費税：￥1,147）<br>
        <br>
        ※このメールの内容に心あたりのない場合は、恐れ入りますが下記弊社お問い合わせ窓口までご連絡頂き、このメールは削除頂けます様、宜しくお願いします。       
      </p>
      <p class="my-5">
        ------------------------------------------------------------------------------------------<br>
        このメールは、配信専用のアドレスで配信されています。<br>
        このメールに返信頂いた内容についてはご確認、ご返答いたしかねますのであらかじめご了承ください。<br>
        このメールの内容についてのお問い合わせは、下記の連絡先までお願いします。<br>
        <br>
        株式会社マナビス化粧品お問い合わせ窓口
        電話：0120-268-510（平日：9:00～17:00）<br>
        ------------------------------------------------------------------------------------------
      </p>
    </div>
  </section>
</template>
<script>

export default {
  mounted() {
    window.scroll(0, 0);
  }
};

</script>
